import { Modal } from 'react-bootstrap';
import { useState } from "react";
import { validEmail, notNullOrEmpty, validUKPhoneNumber, validateField } from "../../utils/validators";
import { FloatingEmailInput } from "../reusable-elements/floating-email-input";
import { FloatingTextInput } from "../reusable-elements/floating-text-input";
import Comparer from "../../app/comparer";

export const NewUserModal = ({ companyName, show, handleCancel, handleSave }) => {

    const comparer = new Comparer();
    const defaultUser = { emailAddress: null, displayName: null, jobTitle: null, companyName, givenName: null, surname: null, phoneNumber: null };

    const [newUser, setNewUser] = useState(structuredClone(defaultUser));
    const [validationErrors, setValidationErrors] = useState(null);
    const [rerender, setRerender] = useState(false);

    const validateState = newState => {
        // Validate fields that the user can change and that you care about the contents of
        validateField(() => notNullOrEmpty(newState.emailAddress) && validEmail(newState.emailAddress), () => newState.emailAddress, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.displayName), () => newState.displayName, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.jobTitle), () => newState.jobTitle, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.givenName), () => newState.givenName, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.surname), () => newState.surname, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.phoneNumber), () => newState.phoneNumber, setValidationErrors);
    };

    const handleStateUpdates = updateMethod => {

        setNewUser(current => {
            const newState = updateMethod(current);
            validateState(newState);
            return newState;
        });
        setRerender(!rerender);

    };
    const hasChanges = () => {
        const equal = comparer.equals(newUser, defaultUser);
        return !equal;
    };

    const canSave = () => {
        return hasChanges() && Object.keys(validationErrors ?? {}).length === 0;
    };

    const localHandleCancel = () => {
        setNewUser(structuredClone(defaultUser));
        handleCancel();
    }

    /*
  
        ArgumentNullException.ThrowIfNull(newUser.PhoneNumber, nameof(newUser.PhoneNumber));
     */

    return (
        <Modal
            show={show}
            onHide={localHandleCancel}
            backdrop="static"
            keyboard={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newUser.displayName ? "Enter" : ""} Display Name`}
                    text={newUser.displayName}
                    updateCallback={newValue => { handleStateUpdates(v => { v.displayName = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newUser.displayName) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newUser.jobTitle ? "Enter" : ""} Job Title`}
                    text={newUser.jobTitle}
                    updateCallback={newValue => { handleStateUpdates(v => { v.jobTitle = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newUser.jobTitle) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newUser.givenName ? "Enter" : ""} First Name`}
                    text={newUser.givenName}
                    updateCallback={newValue => { handleStateUpdates(v => { v.givenName = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newUser.givenName) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newUser.surname ? "Enter" : ""} Last Name`}
                    text={newUser.surname}
                    updateCallback={newValue => { handleStateUpdates(v => { v.surname = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newUser.surname) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newUser.phoneNumber ? "Enter" : ""} Phone Number`}
                    text={newUser.surname}
                    updateCallback={newValue => { handleStateUpdates(v => { v.phoneNumber = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newUser.phoneNumber) && validUKPhoneNumber(newUser.phoneNumber) }}
                    readOnly={false}
                />
                <FloatingEmailInput
                    className={"mt-1"}
                    label={`${!newUser.emailAddress ? "Enter" : ""} Email Address`}
                    email={newUser.emailAddress}
                    updateCallback={newValue => { handleStateUpdates(v => { v.emailAddress = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newUser.emailAddress) && validEmail(newUser.emailAddress); }}
                    readOnly={false}
                />
                <div className='text-muted mt-2'>
                n.b. All users are granted the Basic User role. After they have accepted the invite, you can update their roles.
                </div>
                
            </Modal.Body>
            <Modal.Footer>
                <div className='btn-group'>
                    <button disabled={!canSave()} className='btn btn-primary' onClick={handleSave}>
                        Save
                    </button>
                    <button className='btn btn-secondary' onClick={localHandleCancel}>
                        Close
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );

};